import { Box, Grid, Stack, Typography } from '@mui/material'
import { t } from 'i18next'


const ReviewActionWebhook = ({ actionName, webhookConfig }) => {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid
        container
        marginY={2}
        spacing={2}
      >
        <Grid
          size={6}
          py={1}
        >
          <Typography
            variant="h5"
            align="right"
          >
            {t('actions.actionName')}
          </Typography>
        </Grid>
        <Grid
          size={6}
          py={1}
        >
          <Typography sx={{ lineHeight: '1.2' }}>{actionName}</Typography>
        </Grid>

        <Grid
          size={6}
          py={1}
        >
          <Typography
            variant="h5"
            align="right"
          >
            {t('actions.actionUrl')}
          </Typography>
        </Grid>
        <Grid
          size={6}
          py={1}
        >
          <Typography sx={{ lineHeight: '1.2' }}>
            {webhookConfig.urlAction}
          </Typography>
        </Grid>

        <Grid
          size={6}
          py={1}
        >
          <Typography
            variant="h5"
            align="right"
          >
            {t('actions.sendTriggerInformation')}
          </Typography>
        </Grid>
        <Grid
          size={6}
          py={1}
        >
          <Typography sx={{ lineHeight: '1.2' }}>
            {webhookConfig.sendTriggerInformation ? 'Si' : 'No'}
          </Typography>
        </Grid>

        <Grid
          size={6}
          py={1}
        >
          <Typography
            variant="h5"
            align="right"
          >
            {t('actions.httpHeaders')}
          </Typography>
        </Grid>
        <Grid
          size={6}
          py={1}
        >
          {webhookConfig && webhookConfig.httpHeaders
            ? Object.keys(webhookConfig.httpHeaders).map((key, index) => (
              <Stack
                direction={'row'}
                spacing={2}
                key={index}
              >
                <Typography variant="body">{key}:</Typography>
                <Typography variant="body">
                  {webhookConfig.httpHeaders[key]}
                </Typography>
              </Stack>
            ))
            : ''}
        </Grid>
        <Grid
          size={6}
          py={1}
        >
          <Typography
            variant="h5"
            align="right"
          >
            HMAC
          </Typography>
        </Grid>
        <Grid
          size={6}
          py={1}
        >
          {webhookConfig && webhookConfig.payloadEncoding && webhookConfig.payloadEncoding?.hmacEnabled ?
            <Stack
              direction={'row'}
              spacing={2}
            >
              <Typography variant="body">
                Header: {webhookConfig.payloadEncoding?.hmacHeaderName},
              </Typography>
              <Typography variant="body">
                Key: {webhookConfig.payloadEncoding?.hmacKey}
              </Typography>

            </Stack>
            : ''}
        </Grid>
      </Grid>
    </Box>
  )
}

export default ReviewActionWebhook
